import { FieldLabel, Input, Textarea } from "./Form";
import { designSystemVars as vars } from "../tokens";
import styled from "styled-components";

type ErrorProp = {
  haveError?: string;
};

export const StyledTextInput = styled(Input).withConfig({
  shouldForwardProp: (prop) => prop !== "haveError",
})<ErrorProp>`
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  background-color: ${vars.color.control.background};
  border-radius: ${vars.radius.lg};
  border-width: ${(props) => (props.haveError ? "1.5px" : "1px")};
  border-style: solid;
  border-color: ${(props) =>
    props.haveError
      ? vars.color.control.borderError
      : vars.color.border.accent};
  padding: 0 ${vars.spacing.xl};
  color: ${vars.color.control.text};

  &:focus {
    outline: none;
  }
`;

export const StyledLabelInput = styled(FieldLabel)`
  gap: ${vars.spacing.xs};
  height: auto;
  min-height: 20px;
  font-family: ${vars.typography.family.sans};
  font-size: ${vars.typography.size.sm};
  font-weight: ${vars.typography.weight.medium};
  line-height: var(--inzeloop-ds-line-height-control);
  display: flex;
  align-items: center;
  color: ${vars.color.text.primary};
`;

export const StyledTextAreaInput = styled(Textarea).withConfig({
  shouldForwardProp: (prop) => prop !== "haveError",
})<ErrorProp>`
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  background-color: ${vars.color.control.background};
  border-radius: ${vars.radius.md};
  resize: none;
  border-width: ${(props) => (props.haveError ? "1.5px" : "1px")};
  border-style: solid;
  border-color: ${(props) =>
    props.haveError
      ? vars.color.control.borderError
      : vars.color.border.accent};
  padding: 0 ${vars.spacing.xl};
  color: ${vars.color.control.textSubdued};
  padding-top: var(--inzeloop-ds-spacing-10px);

  &:focus {
    outline: none;
  }
`;
